import constants from "../../../../../helpers/constants";

const tabs = [
  { text: "ACHS Virtual", id: constants.idTabAchsVirtual },
  // { text: "ACHS Gestión", id: constants.idTabAchsGestion },
  // { text: "LGF", id: constants.idTabLGF },
  { text: "Portal Empresa", id: constants.idTabPortalEmpresa },
];

export default {
  isLoading: false,
  isOpenModalEditarRoles: false,
  isOpenLoadingResume: false,
  isOpenSelectRoles: false,
  isOpenSelectGrupos: false,
  selectedTrabajador: {},
  selectedTab: tabs[0],
  sectionTabs: tabs,
  loadingResumeData: {},
  employees: null,
  roles: null,
  grupos: [
    { Name: "grupo1", Id: 1 },
    { Name: "grupo2", Id: 2 },
    { Name: "grupo3", Id: 3 },
  ],
  actualsRoles: [],
  rolesTrabajadorFilterGestion: [],
  rolesEmpresaFilterGestion: [],
  rolesFilter: [],
  userPortalEmpresa: {},
  rolesPortalEmpresa: [],
  gruposPortalEmpresa: [],
  isOpenModalDelRoles: false,
};
